<template>
  <aside
    :class="{
      'active': active,
      'expanded': expanded
    }"
    v-click-outside="reset"
    @click="$emit('lock')"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
  >
    <div class="logo">
      <img id="iconLogo"
        src="@/assets/icon-mamreq.png"
        alt="logo"
        width="50"
      >
      <img id="imgLogo"
        src="@/assets/logo-mamreq2.png"
        alt="logo"
        width="100%"
        style="display: none"
      >
    </div>
    <div class="menus">
      <router-link
        class="link text-nowrap"
        v-for="(menu, m) of menusFiltered"
        :key="m"
        :to="menu.path"
        :exact="menu.exact"
        @click.stop.native="reset"
      >
        <fa-icon
          class="mr-3"
          :icon="menu.icon"
          fixed-width
        />
        <span>
          {{ menu.text }}
        </span>
      </router-link>
      <div
        class="link text-nowrap"
        v-b-toggle.collapse-4
        @click.stop
        v-if="showSurveyData"
      >
        <fa-icon
          class="mr-3"
          icon="file"
          fixed-width
        />
        <span>
          Survey Data
        </span>
      </div>
      <b-collapse
        id="collapse-4"
        class="mt-2 text-nowrap"
      >
        <b-card>
          <router-link
            class="sub-link"
            v-for="(menu, m) of menuSurveyFiltered"
            :key="m"
            :to="menu.path"
            :exact="menu.exact"
            @click.stop.native="reset"
          >
            &bull; {{ menu.text }}
          </router-link>
        </b-card>
      </b-collapse>
      <div
        class="link text-nowrap"
        v-b-toggle.collapse-1
        @click.stop
        v-if="showReport"
      >
        <fa-icon
          class="mr-3"
          icon="clipboard"
          fixed-width
        />
        <span>
          Report
        </span>
      </div>
      <b-collapse
        id="collapse-1"
        class="mt-2 text-nowrap"
      >
        <b-card>
          <router-link
            class="sub-link text-truncate"
            v-for="(menu, m) of menusReportFiltered"
            :key="m"
            :to="menu.path"
            :exact="menu.exact"
            @click.stop.native="reset"
          >
            &bull; {{ menu.text }}
          </router-link>
        </b-card>
      </b-collapse>
      <div
        class="link text-nowrap"
        v-b-toggle.collapse-3
        @click.stop
        v-if="showBup"
      >
        <fa-icon
          class="mr-3"
          icon="hand-holding-usd"
          fixed-width
        />
        <span>
          BUP
        </span>
      </div>
      <b-collapse
        id="collapse-3"
        class="mt-2 text-nowrap"
      >
        <b-card>
          <router-link
            class="sub-link"
            v-for="(menu, m) of menuBupFiltered"
            :key="m"
            :to="menu.path"
            :exact="menu.exact"
            @click.stop.native="reset"
          >
            &bull; {{ menu.text }}
          </router-link>
        </b-card>
      </b-collapse>
      <div
        class="link text-nowrap"
        v-b-toggle.collapse-2
        @click.stop
        v-if="showSettings"
      >
        <fa-icon
          class="mr-3"
          icon="cog"
          fixed-width
        />
        <span>
          Settings
        </span>
      </div>
      <b-collapse
        id="collapse-2"
        class="mt-2 text-nowrap"
      >
        <b-card>
          <router-link
            class="sub-link"
            v-for="(menu, m) of menusSettingsFiltered"
            :key="m"
            :to="menu.path"
            :exact="menu.exact"
            @click.stop.native="reset"
          >
            &bull; {{ menu.text }}
          </router-link>
        </b-card>
      </b-collapse>
    </div>
  </aside>
</template>

<script>
import vClickOutside from 'v-click-outside'
import { hasPermission } from '@/utils/permissions'
import {
  BUDGET_VIEW,
  COMPANY_VIEW,
  DASHBOARD,
  EMPLOYEE_VIEW,
  LOGSHEET_VIEW,
  ROLE_VIEW,
  WORK_ORDER_VIEW,
  CONTRACTOR_VIEW,
  EQUIPMENT_TYPE_VIEW,
  HM_EWH_VIEW,
  SUMMARY_PROGRESS_VIEW,
  SUMMARY_PROGRESS_DATA_SURVEY_VIEW,
  RESUME_VOLUME_WORK_VIEW,
  VOLUME_CALCULATION_VIEW,
  SUMMARY_VIEW,
  RENTAL_EQUIPMENT_VIEW,
  OTHER_VIEW,
  COAL_AUXILLIARY_VIEW,
  OVERBURDEN_VIEW,
  FUEL_PRICE_VIEW,
  PAF_VIEW,
  PAF2_VIEW,
  APPROVAL_DOA_VIEW,
  COAL_LOADING_VIEW
} from '@/fixtures'

export default {
  directives: {
    clickOutside: vClickOutside.directive
  },

  props: {
    active: {
      type: Boolean,
      default: false
    },
    expanded: {
      type: Boolean,
      default: false
    },
    locked: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    menus: [
      {
        path: '/dashboard',
        text: 'Dashboard',
        icon: 'chart-pie',
        permissions: hasPermission(DASHBOARD)
      },
      {
        path: '/budget-plan',
        text: 'Budget/Plan',
        icon: 'shopping-cart',
        permissions: hasPermission(BUDGET_VIEW)
      },
      {
        path: '/work-order',
        text: 'Work Order',
        icon: 'file-alt',
        permissions: hasPermission(WORK_ORDER_VIEW)
      },
      {
        path: '/log-sheet',
        text: 'Log Sheet',
        icon: 'folder',
        permissions: hasPermission(LOGSHEET_VIEW)
      }
    ],
    menuReport: [
      {
        path: '/summary-hm-ewh',
        text: 'Summary HM & EWH',
        permissions: hasPermission(HM_EWH_VIEW)
      },
      {
        path: '/summary-progress',
        text: 'Summary Progress',
        permissions: hasPermission(SUMMARY_PROGRESS_VIEW)
      },
      {
        path: '/payment-auth',
        text: 'Payment Authorization Form',
        permissions: hasPermission(PAF_VIEW || PAF2_VIEW)
      }
    ],
    menuBup: [
      {
        path: '/bup-overburden',
        text: 'Overburden',
        permissions: hasPermission(OVERBURDEN_VIEW)
      },
      {
        path: '/bup-coal-auxilliary',
        text: 'Coal Auxilliary',
        permissions: hasPermission(COAL_AUXILLIARY_VIEW)
      },
      {
        path: '/bup-coal-loading',
        text: 'Coal Loading',
        permissions: hasPermission(COAL_LOADING_VIEW)
      },
      {
        path: '/bup-rental-equipment',
        text: 'Rental Equipment',
        permissions: hasPermission(RENTAL_EQUIPMENT_VIEW)
      },
      {
        path: '/bup-other',
        text: 'Other',
        permissions: hasPermission(OTHER_VIEW)
      },
      {
        path: '/bup-summary',
        text: 'Summary',
        permissions: hasPermission(SUMMARY_VIEW)
      }
    ],
    menuSurvey: [
      {
        path: '/summary-progress-data-survey',
        text: 'Upload Survey Data',
        permissions: hasPermission(SUMMARY_PROGRESS_DATA_SURVEY_VIEW)
      },
      {
        path: '/summary-resume-volume-work',
        text: 'Kemajuan Pekerjaan',
        permissions: hasPermission(RESUME_VOLUME_WORK_VIEW)
      },
      {
        path: '/summary-volume-calculation',
        text: 'Perhitungan Bersama',
        permissions: hasPermission(VOLUME_CALCULATION_VIEW)
      }
    ],
    menuSettings: [
      {
        path: '/fuel-price-exchange-rate',
        text: 'Fuel Price & Exchange Rate',
        permissions: hasPermission(FUEL_PRICE_VIEW)
      },
      {
        path: '/company',
        text: 'Company',
        permissions: hasPermission(COMPANY_VIEW)
      },
      {
        path: '/equipment-type',
        text: 'Equipment Type',
        permissions: hasPermission(EQUIPMENT_TYPE_VIEW)
      },
      {
        path: '/contractor',
        text: 'Contractor',
        permissions: hasPermission(CONTRACTOR_VIEW)
      },
      {
        path: '/employee',
        text: 'Employee',
        permissions: hasPermission(EMPLOYEE_VIEW)
      },
      {
        path: '/user-role-permission',
        text: 'User Role & Permission',
        permissions: hasPermission(ROLE_VIEW)
      },
      {
        path: '/approval-online-doa',
        text: 'Approval Online DOA',
        permissions: hasPermission(APPROVAL_DOA_VIEW)
      }
    ],
    showReport: hasPermission(HM_EWH_VIEW) || hasPermission(SUMMARY_PROGRESS_VIEW) || hasPermission(PAF_VIEW || PAF2_VIEW),
    showSurveyData: hasPermission(SUMMARY_PROGRESS_DATA_SURVEY_VIEW) || hasPermission(RESUME_VOLUME_WORK_VIEW) ||
      hasPermission(VOLUME_CALCULATION_VIEW),
    showBup: hasPermission(OVERBURDEN_VIEW) || hasPermission(COAL_AUXILLIARY_VIEW) || hasPermission(RENTAL_EQUIPMENT_VIEW) ||
      hasPermission(OTHER_VIEW) || hasPermission(SUMMARY_VIEW),
    showSettings: hasPermission(COMPANY_VIEW) || hasPermission(EQUIPMENT_TYPE_VIEW) || hasPermission(CONTRACTOR_VIEW) ||
      hasPermission(EMPLOYEE_VIEW) || hasPermission(ROLE_VIEW) || hasPermission(APPROVAL_DOA_VIEW)
  }),

  computed: {
    menusFiltered() {
      return this.menus
        .filter(menu => menu.permissions)
    },
    menusSettingsFiltered() {
      return this.menuSettings
        .filter(menu => menu.permissions)
    },
    menusReportFiltered() {
      return this.menuReport
        .filter(menu => menu.permissions)
    },
    menuBupFiltered() {
      return this.menuBup
        .filter(menu => menu.permissions)
    },
    menuSurveyFiltered() {
      return this.menuSurvey
        .filter(menu => menu.permissions)
    }
  },

  methods: {
    reset() {
      if (this.active) {
        this.$emit('reset', false)
      }
    },
    onMouseEnter() {
      document.getElementById('imgLogo').style.display = 'block'
      document.getElementById('iconLogo').style.display = 'none'
      this.$emit('expand', true)
    },
    onMouseLeave() {
      if (!this.locked) {
        this.$emit('expand', false)
        document.getElementById('imgLogo').style.display = 'none'
        document.getElementById('iconLogo').style.display = 'block'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~material-colors/dist/colors.scss';

aside {
  background: var(--bg-light-blue);
  bottom: 0;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 0;
  padding: 20px 15px 10px;
  top: 0;
  transform: translateX(-100%);
  transition: 0.3s;
  width: 80px;
  z-index: 103;

  &.active {
    transform: translateX(0);
  }

  &.expanded {
    width: 230px;
  }

  @media screen and (min-width: 992px) {
    transform: translateX(0);
  }
}

.logo {
  align-items: center;
  display: block;
  padding: 15px 0;
  margin-left: auto;
  margin-right: auto;

  .expanded & img {
    clip-path: none;
  }
}

.menus {
  color: #fff;
  margin-bottom: 20px;
  margin-top: 40px;
  overflow: hidden;

  .expanded & {
    overflow-y: auto;
  }
}

.bottom {
  flex-shrink: 0;
  margin-top: auto;
}

.link {
  color: inherit;
  display: block;
  font-size: 14px;
  margin-bottom: 10px;
  padding: 10px 15px;
  position: relative;
  text-decoration: none;

  span {
    display: none;

    .expanded & {
      display: inline-block;
    }
  }
}

.sub-link {
  color: inherit;
  display: block;
  font-size: 12px;
  margin-bottom: 10px;
  padding: 10px 15px;
  position: relative;
  text-decoration: none;
}

.router-link-exact-active {
   background-color: #00B4A5;
   cursor: pointer;
   border-radius: 10px;
 }

.username {
  color: var(--md-grey-700);
  font-size: 0.75em;
  padding: 0 15px;
}

.logout {
  color: #fff;
  display: block;
  padding: 5px 15px;
  text-align: right;
  cursor: pointer;
}

.card {
  background-color: #342570;

  @media screen and (max-width: 992px) {
    background: transparent;
  }
}

.card-body {
  padding: 10px 10px 0 10px;
}

/deep/ .collapse.show {
  height: 0;
  opacity: 0;
  transition: 0.3s;
  visibility: hidden;

  .expanded & {
    height: auto;
    opacity: 1;
    visibility: visible;
  }
}
</style>
